import React, { Component } from "react";
//import "./../lib/amplifyAws/configAmplify";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

// Components
import MenuTop from "./menu/MenuTop";
import MainContent from "./../routes/MainContent";
import AuthRender from "../containers/AuthRender";
import { SERVICES } from "../configs/constants";
import { withRouter } from "react-router-dom";
import MenuLeft from "./menu/MenuLeft";

import { selectUserInfos } from "../redux/selectors/user";
import { serverEnv } from "../configs/config";

const menuTop = [
  {
    label: (
      <FormattedMessage id="menuTopActivity" defaultMessage="Activité">
        {txt => <React.Fragment>{txt}</React.Fragment>}
      </FormattedMessage>
    ),
    id: "activite",
    path: "/activite",
    oneServiceOf: [SERVICES.Planification, SERVICES.Map, SERVICES.Formulaire, SERVICES.Phototeque, SERVICES.Visites]
  },
  // { // Suppression de présence suite au transfert de la gestion des NDF et des présences vers Lucca et Cleemy
  //   label: "Présence",
  //   id: "presence",
  //   path: "/presence",
  //   oneServiceOf: [SERVICES.Planification]
  // },
  {
    label: "Base PDC",
    id: "basepdc",
    path: "/basepdc",
    oneServiceOf: [SERVICES.PDC]
  },
  {
    label: "Imports",
    id: "imports",
    path: "/imports/home",
    oneServiceOf: [SERVICES.Modele, SERVICES.KPI, SERVICES.PDC]
  },
  {
    label: (
      <FormattedMessage id="menuTopStats" defaultMessage="Statistiques">
        {txt => <React.Fragment>{txt}</React.Fragment>}
      </FormattedMessage>
    ),
    id: "stats",
    path: "/stats",
    service: SERVICES.Statistiques
  },
  // {
  //   label: "Download stats",
  //   id: "downloadstats",
  //   path: "/downloadstats",
  //   service: SERVICES.Statistiques
  // },
  // {
  //   label: "Dashboard",
  //   id: "dashboard",
  //   path: "/dashboard",
  //   oneServiceOf: [SERVICES.Statistiques]
  // },
  { label: "Admin", id: "admin", path: "/admin/home", oneServiceOf: [SERVICES.Privileges] },
  { label: "Devs", id: "devs", path: "/devs", oneServiceOf: [SERVICES.Privileges] },
  { label: "Sidely", id: "sidely", path: "/sidely", oneServiceOf: [SERVICES.Privileges] },
  // { label: "Rh", id: "humanResources", path: "/humanResources/home", oneServiceOf: [SERVICES.Privileges] },
  { label: "Compta", id: "accounting", path: "/accounting", oneServiceOf: [SERVICES.Virement] }
];

class Layout extends Component {
  render() {
    const { currentUser, userInfos, currentClient } = this.props;
    const adminWithLimitedAccess = [
      "eric.grasland@upsell.fr",
      "jerome.balay@upsell.fr",
      "thierry.pinon@upsell.fr",
      "virginie.ghorbanian@upsell.fr"
      // "admin1.es@upsell.fr",
      // "admin2.es@upsell.fr",
      // "rh.es@upsell.fr",
      // "assistant.santebeaute@upsell.fr",
      // "testclient@upsell.fr",
      // "thierry.pinon@upsell.fr"
    ];
    const adminWithAccess = [
      "admin1.es@upsell.fr",
      "admin2.es@upsell.fr",
      "tsirizo.rabenoro@upsell.fr",
      "raphael.jouvancy@upsell.fr",
      "david.halifi@upsell.fr",
      "thomas.barbosa@upsell.fr",
      "yves.trang@upsell.fr"
    ];

    const userEmail = (userInfos && userInfos.email) || "";
    // const isAdminWithLimitedAccess = adminWithLimitedAccess.indexOf(userEmail) !== -1;
    const menuTopDataWithAccess = menuTop.filter(v => {
      if (v.id === "admin") return adminWithAccess.indexOf(userEmail) !== -1;
      return true;
      // if (
      //   (isAdminWithLimitedAccess && v.id === "admin") ||
      //   (serverEnv === "PROD" && (v.id === "devs" || v.id === "humanResources"))
      // ) {
      //   return false;
      // } else {
      //   return true;
      // }
    });
    return (
      <div className="p-container">
        <div className="p-menu">
          <MenuTop menuData={menuTopDataWithAccess} {...this.props} />
        </div>
        <div
          id={"p-container-id"}
          className={`p-content ${this.props.location.pathname.indexOf("/stats") !== -1 ? "stats" : null}`}
        >
          {this.props.location.pathname.indexOf("/stats") !== -1 && (
            <MenuLeft stats={true} menuData={menuTopDataWithAccess} {...this.props} />
          )}
          <AuthRender minRole={5}>
            <MainContent currentUser={currentUser} />
          </AuthRender>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: selectUserInfos(state)
  };
};

export default connect(mapStateToProps, null)(withRouter(Layout));
// <MenuLeft userInfos={userInfos} currentClient={currentClient} />



// WEBPACK FOOTER //
// src/components/Layout.js